var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0" },
    [
      _c(
        "v-menu",
        {
          attrs: {
            "position-x": _vm.menu.flags.x,
            "position-y": _vm.menu.flags.y,
            absolute: "",
            "offset-y": "",
            "z-index": "212",
            "close-on-content-click": false,
          },
          model: {
            value: _vm.menu.flags.show,
            callback: function ($$v) {
              _vm.$set(_vm.menu.flags, "show", $$v)
            },
            expression: "menu.flags.show",
          },
        },
        [
          _c(
            "v-list",
            { attrs: { dense: "" } },
            _vm._l(_vm.menu.flags.items, function (item, index) {
              return _c(
                "v-list-tile",
                { key: `flag-${index}` },
                [
                  _c(
                    "v-list-tile-action",
                    [
                      _c("v-checkbox", {
                        attrs: {
                          color: "success",
                          value: item.FlagCode,
                          label: item.FlagText,
                        },
                        model: {
                          value: _vm.menu.datum.UpdatedFlags,
                          callback: function ($$v) {
                            _vm.$set(_vm.menu.datum, "UpdatedFlags", $$v)
                          },
                          expression: "menu.datum.UpdatedFlags",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-menu",
        {
          attrs: {
            "position-x": _vm.menu.media.x,
            "position-y": _vm.menu.media.y,
            absolute: "",
            "offset-y": "",
            "z-index": "212",
          },
          model: {
            value: _vm.menu.media.show,
            callback: function ($$v) {
              _vm.$set(_vm.menu.media, "show", $$v)
            },
            expression: "menu.media.show",
          },
        },
        [
          _c(
            "v-list",
            { attrs: { dense: "" } },
            _vm._l(_vm.menu.media.items, function (item, index) {
              return _c(
                "v-list-tile",
                {
                  key: `media-${index}`,
                  on: {
                    click: function ($event) {
                      return _vm.setItemMedia(item)
                    },
                  },
                },
                [
                  _c(
                    "v-list-tile-title",
                    {
                      class: {
                        "success--text": _vm.isSelectedMedia(item),
                        "font-weight-bold": _vm.isPreviousMedia(item),
                      },
                    },
                    [_vm._v(_vm._s(item) + "\n        ")]
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-menu",
        {
          attrs: {
            "position-x": _vm.menu.datums.x,
            "position-y": _vm.menu.datums.y,
            absolute: "",
            "offset-y": "",
            "z-index": "212",
          },
          model: {
            value: _vm.menu.datums.show,
            callback: function ($$v) {
              _vm.$set(_vm.menu.datums, "show", $$v)
            },
            expression: "menu.datums.show",
          },
        },
        [
          _c(
            "v-list",
            { attrs: { dense: "" } },
            _vm._l(_vm.menu.datums.items, function (item, index) {
              return _c(
                "v-list-tile",
                {
                  key: `datum-${index}`,
                  on: {
                    click: function ($event) {
                      return _vm.setItemDatum(item.DatumText)
                    },
                  },
                },
                [
                  _c(
                    "v-list-tile-title",
                    {
                      class: {
                        "success--text": _vm.isSelectedDatum(item.DatumText),
                        "font-weight-bold": _vm.isPreviousDatum(item.DatumText),
                      },
                    },
                    [_vm._v("\n          " + _vm._s(item.DatumText || "None"))]
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-menu",
        {
          attrs: {
            "position-x": _vm.menu.sampletypes.x,
            "position-y": _vm.menu.sampletypes.y,
            absolute: "",
            "offset-y": "",
            "z-index": "212",
          },
          model: {
            value: _vm.menu.sampletypes.show,
            callback: function ($$v) {
              _vm.$set(_vm.menu.sampletypes, "show", $$v)
            },
            expression: "menu.sampletypes.show",
          },
        },
        [
          _c(
            "v-list",
            { attrs: { dense: "" } },
            _vm._l(_vm.menu.sampletypes.items, function (item, index) {
              return _c(
                "v-list-tile",
                {
                  key: `sampletype-${index}`,
                  on: {
                    click: function ($event) {
                      return _vm.setItemSampleType(item)
                    },
                  },
                },
                [
                  _c(
                    "v-list-tile-title",
                    {
                      class: {
                        "success--text": _vm.isSelectedSampleType(item),
                        "font-weight-bold": _vm.isPreviousSampleType(item),
                      },
                    },
                    [_vm._v(_vm._s(item) + "\n        ")]
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "300" },
          model: {
            value: _vm.menu.depthheight.show,
            callback: function ($$v) {
              _vm.$set(_vm.menu.depthheight, "show", $$v)
            },
            expression: "menu.depthheight.show",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                [
                  _c("v-subheader", [_vm._v("Start Value")]),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      label: "Enter start value in m",
                      rules: [_vm.rules.depthHeightRules],
                    },
                    model: {
                      value: _vm.depthHeightStartValue,
                      callback: function ($$v) {
                        _vm.depthHeightStartValue = $$v
                      },
                      expression: "depthHeightStartValue",
                    },
                  }),
                  _vm._v(" "),
                  _c("v-subheader", [_vm._v("End Value")]),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      label: "Enter end value in m",
                      rules: [_vm.rules.depthHeightRules],
                    },
                    model: {
                      value: _vm.depthHeightEndValue,
                      callback: function ($$v) {
                        _vm.depthHeightEndValue = $$v
                      },
                      expression: "depthHeightEndValue",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        small: "",
                        color: "success",
                        disabled: _vm.saveButtonDisabled,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.saveDepthHeight()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [_vm._v("done")]),
                      _vm._v(_vm._s(_vm.$t("Button.Save")) + "\n        "),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { small: "", color: "secondary", outline: "" },
                      on: {
                        click: function ($event) {
                          return _vm.closeDialog()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "content-class": "tabular-dialog", persistent: "" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-layout",
                { staticStyle: { "flex-direction": "column" } },
                [
                  _c(
                    "v-flex",
                    { staticStyle: { flex: "0 0 64px" } },
                    [
                      _c(
                        "v-toolbar",
                        { attrs: { dark: "", color: "primary" } },
                        [
                          _c(
                            "v-toolbar-title",
                            [
                              _vm.timeRange && _vm.timeRange[0]
                                ? [
                                    _vm._v(
                                      "Tabular view - " +
                                        _vm._s(
                                          _vm.formatDate(
                                            _vm.timeRange[0],
                                            _vm.dateFormat
                                          )
                                        ) +
                                        " to\n                " +
                                        _vm._s(
                                          _vm.formatDate(
                                            _vm.timeRange[1],
                                            _vm.dateFormat
                                          )
                                        )
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "", dark: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.close()
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("close")])],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.hasMismatchedUnitGroup.length
                    ? _c(
                        "v-alert",
                        {
                          staticClass: "ma-0",
                          attrs: {
                            value: true,
                            color: "warning lighten-2",
                            icon: "warning",
                            outline: "",
                          },
                        },
                        [
                          _c("div", { staticClass: "primary--text" }, [
                            _c("div", [
                              _vm._v("\n              The following "),
                              _vm.hasMismatchedUnitGroup.length == 1
                                ? _c("span", [_vm._v("analyte")])
                                : _c("span", [_vm._v("analytes")]),
                              _vm._v(
                                " in the query results contain data with units inconsistent with analyte unit group:\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c(
                                "ul",
                                _vm._l(
                                  _vm.hasMismatchedUnitGroup,
                                  function (i, index) {
                                    return _c("li", { key: index }, [
                                      _vm._v(_vm._s(i)),
                                    ])
                                  }
                                ),
                                0
                              ),
                            ]),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticStyle: {
                        flex: "1 1 0%",
                        "min-width": "0",
                        "min-height": "0",
                      },
                    },
                    [
                      _c(
                        "v-layout",
                        { staticStyle: { height: "100%" } },
                        [
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                flex: "1 1 0%",
                                "background-color": "#f7f7f7",
                                "min-height": "0",
                                "min-width": "200px",
                                display: "flex",
                                "flex-direction": "column",
                              },
                              attrs: { md2: "", xs2: "" },
                            },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass: "px-2",
                                  staticStyle: {
                                    flex: "0 0 57px",
                                    "background-color": "white",
                                    "border-bottom": "1px solid #e5e5e5",
                                    "min-width": "0",
                                  },
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      loading: _vm.isSearching,
                                      disabled: _vm.loading || _vm.isSaving,
                                      "append-icon": "search",
                                      "hide-details": "",
                                      "full-width": "",
                                      label: "Search analytes",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.search,
                                      callback: function ($$v) {
                                        _vm.search = $$v
                                      },
                                      expression: "search",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { staticStyle: { "min-height": "0" } },
                                [
                                  _c(
                                    "v-container",
                                    {
                                      staticStyle: {
                                        overflow: "auto",
                                        height: "100%",
                                      },
                                    },
                                    [
                                      _vm.hasMismatchedUnitGroup.length
                                        ? [
                                            _c(
                                              "v-layout",
                                              {
                                                staticStyle: {
                                                  "margin-bottom": "5px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-flex",
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          color:
                                                            "warning lighten-2",
                                                        },
                                                      },
                                                      [_vm._v("palette")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("v-flex", [
                                                  _vm._v(
                                                    "Data with mismatched unit are highlighted."
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.hasUpdate
                                        ? [
                                            _c(
                                              "v-layout",
                                              {
                                                staticStyle: {
                                                  margin: "7px 0 7px 0",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-flex",
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          color: "#cad2ff",
                                                        },
                                                      },
                                                      [_vm._v("palette")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("v-flex", [
                                                  _vm._v(
                                                    "Modified data are highlighted."
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.hasInvalidDatumData
                                        ? [
                                            _c(
                                              "v-layout",
                                              {
                                                staticStyle: {
                                                  margin: "7px 0 7px 0",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-flex",
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          color: "#bb1a22b3",
                                                        },
                                                      },
                                                      [_vm._v("palette")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("v-flex", [
                                                  _vm._v(
                                                    "Data with incompleted datum and depth height values are highlighted."
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("v-divider"),
                                      _vm._v(" "),
                                      _vm.loading
                                        ? [
                                            _c(
                                              "v-list",
                                              {
                                                staticStyle: {
                                                  "background-color":
                                                    "transparent",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "subheading" },
                                                  [_vm._v("Flags")]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(2, function (index) {
                                                  return [
                                                    _c(
                                                      "v-list-tile",
                                                      { key: index },
                                                      [
                                                        _c(
                                                          "v-list-tile-content",
                                                          [
                                                            _c(
                                                              "v-list-tile-title",
                                                              {
                                                                staticClass:
                                                                  "loading-skeleton-1",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                              " +
                                                                    _vm._s(
                                                                      index
                                                                    ) +
                                                                    " -\n                              "
                                                                ),
                                                                _c("small", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      index
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                }),
                                              ],
                                              2
                                            ),
                                          ]
                                        : [
                                            _c(
                                              "v-list",
                                              {
                                                staticStyle: {
                                                  "background-color":
                                                    "transparent",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "subheading" },
                                                  [_vm._v("Flags")]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.selectFlags,
                                                  function (item, i) {
                                                    return [
                                                      _c(
                                                        "v-list-tile",
                                                        { key: i },
                                                        [
                                                          _c(
                                                            "v-list-tile-content",
                                                            {
                                                              staticStyle: {
                                                                display: "flex",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-tile-title",
                                                                {
                                                                  staticClass:
                                                                    "flags",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                              " +
                                                                      _vm._s(
                                                                        item.FlagCode
                                                                      ) +
                                                                      " -\n                              "
                                                                  ),
                                                                  _c("small", [
                                                                    _vm._v(
                                                                      "\n                                " +
                                                                        _vm._s(
                                                                          item.Description
                                                                        ) +
                                                                        "\n                                "
                                                                    ),
                                                                    !item.ShowValues &&
                                                                    !_vm.isShowAll
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "(excluded)"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                      _vm._v(" "),
                                      _c("v-divider"),
                                      _vm._v(" "),
                                      [
                                        _c(
                                          "v-list",
                                          {
                                            staticStyle: {
                                              "background-color": "transparent",
                                            },
                                            attrs: { subheader: "" },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "subheading mt-2",
                                              },
                                              [_vm._v("Settings")]
                                            ),
                                            _vm._v(" "),
                                            _c("v-switch", {
                                              attrs: {
                                                color: "success",
                                                disabled:
                                                  _vm.loading || _vm.isSaving,
                                                "hide-details": "",
                                                label:
                                                  "Show values hidden by flags",
                                              },
                                              model: {
                                                value: _vm.isShowAll,
                                                callback: function ($$v) {
                                                  _vm.isShowAll = $$v
                                                },
                                                expression: "isShowAll",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("v-switch", {
                                              attrs: {
                                                color: "success",
                                                disabled:
                                                  _vm.loading || _vm.isSaving,
                                                "hide-details": "",
                                                label: "Show all columns",
                                              },
                                              model: {
                                                value: _vm.showAllHeaders,
                                                callback: function ($$v) {
                                                  _vm.showAllHeaders = $$v
                                                },
                                                expression: "showAllHeaders",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("v-switch", {
                                              attrs: {
                                                color: "success",
                                                disabled:
                                                  _vm.loading || _vm.isSaving,
                                                "hide-details": "",
                                                label:
                                                  "Show Envirodata Analyte Name",
                                              },
                                              model: {
                                                value:
                                                  _vm.requestData
                                                    .includeAnalyteName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.requestData,
                                                    "includeAnalyteName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "requestData.includeAnalyteName",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("v-switch", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: false,
                                                  expression: "false",
                                                },
                                              ],
                                              attrs: {
                                                color: "success",
                                                disabled:
                                                  _vm.loading || _vm.isSaving,
                                                "hide-details": "",
                                                label: "Slow mode (large data)",
                                              },
                                              model: {
                                                value: _vm.slowMode,
                                                callback: function ($$v) {
                                                  _vm.slowMode = $$v
                                                },
                                                expression: "slowMode",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      _vm._v(" "),
                                      _c(
                                        "transition",
                                        { attrs: { name: "fade" } },
                                        [
                                          !_vm.loading && _vm.isEditing
                                            ? _c(
                                                "v-list",
                                                {
                                                  staticStyle: {
                                                    "background-color":
                                                      "transparent",
                                                  },
                                                },
                                                [
                                                  _c("v-divider"),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "subheading mt-2",
                                                    },
                                                    [_vm._v("Bulk Edit")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("v-select", {
                                                    staticStyle: {
                                                      border: "1px solid #ddd",
                                                    },
                                                    attrs: {
                                                      items: _vm.selectFlags,
                                                      disabled: _vm.isSaving,
                                                      label: "Add flags",
                                                      multiple: "",
                                                      flat: "",
                                                      clearable: "",
                                                      "item-text": "FlagText",
                                                      "item-value": "FlagCode",
                                                      solo: "",
                                                      "hide-details": "",
                                                      color: "success",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "selection",
                                                          fn: function ({
                                                            item,
                                                            index,
                                                          }) {
                                                            return [
                                                              index === 0
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.addFlagsData.join(
                                                                          ", "
                                                                        )
                                                                      )
                                                                    ),
                                                                  ])
                                                                : _vm._e(),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      4232617253
                                                    ),
                                                    model: {
                                                      value: _vm.addFlagsData,
                                                      callback: function ($$v) {
                                                        _vm.addFlagsData = $$v
                                                      },
                                                      expression:
                                                        "addFlagsData",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("v-select", {
                                                    staticClass: "mt-1",
                                                    staticStyle: {
                                                      border: "1px solid #ddd",
                                                    },
                                                    attrs: {
                                                      disabled: _vm.isSaving,
                                                      items:
                                                        _vm.menu.media.items,
                                                      label: "Set Media",
                                                      flat: "",
                                                      clearable: "",
                                                      solo: "",
                                                      "hide-details": "",
                                                      color: "success",
                                                    },
                                                    model: {
                                                      value: _vm.setMediaData,
                                                      callback: function ($$v) {
                                                        _vm.setMediaData = $$v
                                                      },
                                                      expression:
                                                        "setMediaData",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("v-select", {
                                                    staticClass: "mt-1",
                                                    staticStyle: {
                                                      border: "1px solid #ddd",
                                                    },
                                                    attrs: {
                                                      disabled: _vm.isSaving,
                                                      items:
                                                        _vm.menu.sampletypes
                                                          .items,
                                                      label: "Set Sample Type",
                                                      flat: "",
                                                      clearable: "",
                                                      solo: "",
                                                      "hide-details": "",
                                                      color: "success",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.setSampleTypeData,
                                                      callback: function ($$v) {
                                                        _vm.setSampleTypeData =
                                                          $$v
                                                      },
                                                      expression:
                                                        "setSampleTypeData",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("v-select", {
                                                    staticClass: "mt-1",
                                                    staticStyle: {
                                                      border: "1px solid #ddd",
                                                    },
                                                    attrs: {
                                                      disabled: _vm.isSaving,
                                                      items: _vm.selectDatum,
                                                      label: "Set Datum",
                                                      flat: "",
                                                      clearable: "",
                                                      "item-text": "DatumText",
                                                      "item-value": "DatumText",
                                                      solo: "",
                                                      "hide-details": "",
                                                      color: "success",
                                                    },
                                                    model: {
                                                      value: _vm.setDatumData,
                                                      callback: function ($$v) {
                                                        _vm.setDatumData = $$v
                                                      },
                                                      expression:
                                                        "setDatumData",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("v-text-field", {
                                                    staticClass: "mt-1",
                                                    staticStyle: {
                                                      border: "1px solid #ddd",
                                                    },
                                                    attrs: {
                                                      solo: "",
                                                      flat: "",
                                                      "hide-details": "",
                                                      clearable: "",
                                                      disabled: _vm.isSaving,
                                                      label:
                                                        "Set start value in m",
                                                    },
                                                    model: {
                                                      value: _vm.setStartValue,
                                                      callback: function ($$v) {
                                                        _vm.setStartValue = $$v
                                                      },
                                                      expression:
                                                        "setStartValue",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("v-text-field", {
                                                    staticClass: "mt-1",
                                                    staticStyle: {
                                                      border: "1px solid #ddd",
                                                    },
                                                    attrs: {
                                                      solo: "",
                                                      flat: "",
                                                      "hide-details": "",
                                                      clearable: "",
                                                      disabled: _vm.isSaving,
                                                      label:
                                                        "Set end value in m",
                                                    },
                                                    model: {
                                                      value: _vm.setEndValue,
                                                      callback: function ($$v) {
                                                        _vm.setEndValue = $$v
                                                      },
                                                      expression: "setEndValue",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "mx-0",
                                                      attrs: {
                                                        loading: _vm.isAddBulk,
                                                        disabled:
                                                          _vm.isSaving ||
                                                          (_vm.addFlagsData
                                                            .length == 0 &&
                                                            _vm.setMediaData ==
                                                              null &&
                                                            _vm.setSampleTypeData ==
                                                              null &&
                                                            _vm.setDatumData ==
                                                              null &&
                                                            (_vm.setStartValue ==
                                                              null ||
                                                              _vm.setEndValue ==
                                                                null)) ||
                                                          !(
                                                            _vm.isPartialSelection ||
                                                            _vm.selectAll
                                                          ),
                                                        color: "success",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.addBulk()
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        { staticClass: "mr-1" },
                                                        [_vm._v("add")]
                                                      ),
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.$t("Button.Add")
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                "min-width": "0",
                                display: "flex",
                                "flex-direction": "column",
                              },
                              attrs: { md10: "", xs10: "" },
                            },
                            [
                              _c(
                                "v-flex",
                                { staticStyle: { flex: "0 0 57px" } },
                                [
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-card-text",
                                        {
                                          ref: "virtualCollectionHeader",
                                          staticClass:
                                            "card_text pa-0 rowHeader",
                                          staticStyle: {
                                            "overflow-x": "hidden",
                                          },
                                        },
                                        [
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "v-table v-datatable--select-all theme--light",
                                            },
                                            [
                                              _c(
                                                "thead",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "tr",
                                                    {
                                                      staticClass:
                                                        "text-xs-left",
                                                      staticStyle: {
                                                        width: "100%",
                                                        display: "flex",
                                                        "border-bottom": "none",
                                                      },
                                                    },
                                                    [
                                                      _vm._l(
                                                        _vm.headers,
                                                        function (
                                                          header,
                                                          index
                                                        ) {
                                                          return [
                                                            [
                                                              header.text ==
                                                              "Select"
                                                                ? _c(
                                                                    "th",
                                                                    {
                                                                      directives:
                                                                        [
                                                                          {
                                                                            name: "show",
                                                                            rawName:
                                                                              "v-show",
                                                                            value:
                                                                              !header.hide,
                                                                            expression:
                                                                              "!header.hide",
                                                                          },
                                                                        ],
                                                                      key: `th-${index}`,
                                                                      staticClass:
                                                                        "column active sortable pa-0 d-flex align-center max-width",
                                                                      style:
                                                                        _vm.getCellStyle(
                                                                          header
                                                                        ),
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "transition",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              name: "fade",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm.isEditing
                                                                            ? _c(
                                                                                "v-checkbox",
                                                                                {
                                                                                  staticClass:
                                                                                    "th-checkbox py-0 px-2 ma-0",
                                                                                  attrs:
                                                                                    {
                                                                                      color:
                                                                                        "primary",
                                                                                      disabled:
                                                                                        _vm.loading ||
                                                                                        _vm.isSaving,
                                                                                      indeterminate:
                                                                                        _vm.isPartialSelection,
                                                                                      "hide-details":
                                                                                        "",
                                                                                    },
                                                                                  model:
                                                                                    {
                                                                                      value:
                                                                                        _vm.selectAll,
                                                                                      callback:
                                                                                        function (
                                                                                          $$v
                                                                                        ) {
                                                                                          _vm.selectAll =
                                                                                            $$v
                                                                                        },
                                                                                      expression:
                                                                                        "selectAll",
                                                                                    },
                                                                                }
                                                                              )
                                                                            : _vm._e(),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                : _c(
                                                                    "SlicedHeader",
                                                                    {
                                                                      directives:
                                                                        [
                                                                          {
                                                                            name: "show",
                                                                            rawName:
                                                                              "v-show",
                                                                            value:
                                                                              !header.hide,
                                                                            expression:
                                                                              "!header.hide",
                                                                          },
                                                                        ],
                                                                      key: `th-${index}`,
                                                                      ref: "slicedHeaders",
                                                                      refInFor: true,
                                                                      attrs: {
                                                                        headerStyle:
                                                                          _vm.getCellStyle(
                                                                            header
                                                                          ),
                                                                        header:
                                                                          header,
                                                                        sortable:
                                                                          !!header.sorter,
                                                                        active:
                                                                          _vm.isActiveSort(
                                                                            header
                                                                          ),
                                                                        descending:
                                                                          _vm
                                                                            .sort
                                                                            .descending,
                                                                        data: _vm.items,
                                                                        disabled:
                                                                          _vm.loading ||
                                                                          _vm.isSaving,
                                                                        slowMode:
                                                                          _vm.slowMode,
                                                                      },
                                                                      on: {
                                                                        slice:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.onSlice()
                                                                          },
                                                                        sort: function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.onSort(
                                                                            header
                                                                          )
                                                                        },
                                                                      },
                                                                    }
                                                                  ),
                                                            ],
                                                          ]
                                                        }
                                                      ),
                                                      _vm._v(" "),
                                                      !_vm.loading
                                                        ? _c("th", {
                                                            staticStyle: {
                                                              width: "0px",
                                                              "min-width":
                                                                "0px",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    2
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "virtual-collection-flex",
                                  staticStyle: {
                                    flex: "1 0 0%",
                                    "min-height": "0",
                                    "min-width": "0",
                                    overflow: "hidden",
                                  },
                                },
                                [
                                  _c(
                                    "v-card-text",
                                    {
                                      staticClass: "card_text pa-0",
                                      staticStyle: {
                                        height: "100%",
                                        display: "block",
                                      },
                                    },
                                    [
                                      _c(
                                        "table",
                                        {
                                          ref: "dataTable",
                                          staticStyle: { display: "block" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.showItemMenu($event)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "tbody",
                                            {
                                              ref: "virtualContainer",
                                              staticStyle: { display: "block" },
                                            },
                                            [
                                              _vm.loading
                                                ? _vm._l(
                                                    _vm.skeletonDataItems,
                                                    function (index) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: `row-${index}`,
                                                          staticClass:
                                                            "cell-container",
                                                          staticStyle: {
                                                            height: "48px",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-layout",
                                                            {
                                                              staticClass:
                                                                "row",
                                                            },
                                                            [
                                                              _vm._l(
                                                                _vm.headers,
                                                                function (
                                                                  header,
                                                                  index
                                                                ) {
                                                                  return [
                                                                    _c(
                                                                      "v-flex",
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "show",
                                                                              rawName:
                                                                                "v-show",
                                                                              value:
                                                                                !header.hide,
                                                                              expression:
                                                                                "!header.hide",
                                                                            },
                                                                          ],
                                                                        key: `cell-${index}`,
                                                                        class: `cell cell${header.value}`,
                                                                        style:
                                                                          _vm.getCellStyle(
                                                                            header
                                                                          ),
                                                                        attrs: {
                                                                          id: `cell${header.value}`,
                                                                        },
                                                                      },
                                                                      [
                                                                        header.text ==
                                                                        "Select"
                                                                          ? _c(
                                                                              "div",
                                                                              [
                                                                                _c(
                                                                                  "transition",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        name: "fade",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _vm.isEditing
                                                                                      ? _c(
                                                                                          "v-checkbox",
                                                                                          {
                                                                                            staticClass:
                                                                                              "cell-checkbox",
                                                                                            attrs:
                                                                                              {
                                                                                                color:
                                                                                                  "success",
                                                                                                disabled:
                                                                                                  "",
                                                                                                "hide-details":
                                                                                                  "",
                                                                                              },
                                                                                          }
                                                                                        )
                                                                                      : _vm._e(),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ],
                                                                              1
                                                                            )
                                                                          : _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "loading-skeleton-1",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .skeletonData[
                                                                                      index
                                                                                    ]
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                }
                                                              ),
                                                            ],
                                                            2
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  )
                                                : [
                                                    _c("VirtualCollection", {
                                                      ref: "virtualCollection",
                                                      attrs: {
                                                        cellSizeAndPositionGetter:
                                                          _vm.cellSizeAndPositionGetter,
                                                        collection:
                                                          _vm.collectionItems,
                                                        height:
                                                          _vm.dom
                                                            .containerHeight,
                                                        width:
                                                          _vm.dom
                                                            .containerWidth,
                                                      },
                                                      scopedSlots: _vm._u([
                                                        {
                                                          key: "cell",
                                                          fn: function (props) {
                                                            return [
                                                              _c(
                                                                "v-layout",
                                                                {
                                                                  staticClass:
                                                                    "row",
                                                                  class: [
                                                                    {
                                                                      "row-selected":
                                                                        _vm
                                                                          .selected[
                                                                          props
                                                                            .data
                                                                            .Id
                                                                        ].value,
                                                                    },
                                                                    `item-background-${_vm.decideBackgroundColor(
                                                                      props.data
                                                                    )}`,
                                                                  ],
                                                                  attrs: {
                                                                    id: `row-${props.data.Id}`,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._l(
                                                                    _vm.headers,
                                                                    function (
                                                                      header,
                                                                      index
                                                                    ) {
                                                                      return [
                                                                        _c(
                                                                          "v-flex",
                                                                          {
                                                                            directives:
                                                                              [
                                                                                {
                                                                                  name: "show",
                                                                                  rawName:
                                                                                    "v-show",
                                                                                  value:
                                                                                    !header.hide,
                                                                                  expression:
                                                                                    "!header.hide",
                                                                                },
                                                                              ],
                                                                            key: `cell-${index}`,
                                                                            class:
                                                                              {
                                                                                [`cell cell${header.value}`]: true,
                                                                              },
                                                                            style:
                                                                              _vm.getCellStyle(
                                                                                header
                                                                              ),
                                                                            attrs:
                                                                              {
                                                                                id: `cell${header.value}-${props.data.Id}`,
                                                                              },
                                                                          },
                                                                          [
                                                                            header.text ==
                                                                            "Select"
                                                                              ? [
                                                                                  _c(
                                                                                    "transition",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          name: "fade",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm.isEditing
                                                                                        ? _c(
                                                                                            "v-checkbox",
                                                                                            {
                                                                                              staticClass:
                                                                                                "cell-checkbox",
                                                                                              attrs:
                                                                                                {
                                                                                                  color:
                                                                                                    "success",
                                                                                                  disabled:
                                                                                                    _vm.isSaving,
                                                                                                  "hide-details":
                                                                                                    "",
                                                                                                },
                                                                                              on: {
                                                                                                change:
                                                                                                  function (
                                                                                                    $event
                                                                                                  ) {
                                                                                                    return _vm.trackCheckbox(
                                                                                                      props
                                                                                                        .data
                                                                                                        .Id
                                                                                                    )
                                                                                                  },
                                                                                              },
                                                                                              model:
                                                                                                {
                                                                                                  value:
                                                                                                    _vm
                                                                                                      .selected[
                                                                                                      props
                                                                                                        .data
                                                                                                        .Id
                                                                                                    ]
                                                                                                      .value,
                                                                                                  callback:
                                                                                                    function (
                                                                                                      $$v
                                                                                                    ) {
                                                                                                      _vm.$set(
                                                                                                        _vm
                                                                                                          .selected[
                                                                                                          props
                                                                                                            .data
                                                                                                            .Id
                                                                                                        ],
                                                                                                        "value",
                                                                                                        $$v
                                                                                                      )
                                                                                                    },
                                                                                                  expression:
                                                                                                    "selected[props.data.Id].value",
                                                                                                },
                                                                                            }
                                                                                          )
                                                                                        : _vm._e(),
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                                ]
                                                                              : header.value ==
                                                                                "CocCode"
                                                                              ? _c(
                                                                                  "span",
                                                                                  {
                                                                                    domProps:
                                                                                      {
                                                                                        innerHTML:
                                                                                          _vm._s(
                                                                                            _vm.generateLinkHtml(
                                                                                              props
                                                                                                .data[
                                                                                                header
                                                                                                  .value
                                                                                              ],
                                                                                              props.data
                                                                                            )
                                                                                          ),
                                                                                      },
                                                                                  }
                                                                                )
                                                                              : header.value ==
                                                                                "DateTime"
                                                                              ? _c(
                                                                                  "span",
                                                                                  {
                                                                                    domProps:
                                                                                      {
                                                                                        innerHTML:
                                                                                          _vm._s(
                                                                                            header.format(
                                                                                              props
                                                                                                .data
                                                                                                .DateTime
                                                                                            )
                                                                                          ),
                                                                                      },
                                                                                  }
                                                                                )
                                                                              : header.value ==
                                                                                "DepthHeight"
                                                                              ? [
                                                                                  _vm.isEditing
                                                                                    ? _c(
                                                                                        "v-btn",
                                                                                        {
                                                                                          staticClass:
                                                                                            "dropdown-btn",
                                                                                          attrs:
                                                                                            {
                                                                                              disabled:
                                                                                                _vm.isSaving,
                                                                                              small:
                                                                                                "",
                                                                                              block:
                                                                                                "",
                                                                                              flat: "",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "span",
                                                                                            {
                                                                                              class:
                                                                                                {
                                                                                                  "success--text":
                                                                                                    props
                                                                                                      .data
                                                                                                      .UpdatedDepthHeight !=
                                                                                                    props
                                                                                                      .data
                                                                                                      .DepthHeight,
                                                                                                },
                                                                                              domProps:
                                                                                                {
                                                                                                  innerHTML:
                                                                                                    _vm._s(
                                                                                                      props
                                                                                                        .data
                                                                                                        .UpdatedDepthHeight
                                                                                                    ),
                                                                                                },
                                                                                            }
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          _c(
                                                                                            "v-icon",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  small:
                                                                                                    "",
                                                                                                },
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                "edit"
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                    : void 0,
                                                                                ]
                                                                              : header.value ==
                                                                                "DatumText"
                                                                              ? [
                                                                                  _vm.isEditing
                                                                                    ? _c(
                                                                                        "v-btn",
                                                                                        {
                                                                                          staticClass:
                                                                                            "dropdown-btn",
                                                                                          attrs:
                                                                                            {
                                                                                              disabled:
                                                                                                _vm.isSaving,
                                                                                              small:
                                                                                                "",
                                                                                              block:
                                                                                                "",
                                                                                              flat: "",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "span",
                                                                                            {
                                                                                              class:
                                                                                                {
                                                                                                  "success--text":
                                                                                                    props
                                                                                                      .data
                                                                                                      .UpdatedDatumText !=
                                                                                                    props
                                                                                                      .data
                                                                                                      .DatumText,
                                                                                                },
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                _vm._s(
                                                                                                  props
                                                                                                    .data
                                                                                                    .UpdatedDatumText
                                                                                                )
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          _c(
                                                                                            "v-icon",
                                                                                            [
                                                                                              _vm._v(
                                                                                                "arrow_drop_down"
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                    : [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            props
                                                                                              .data
                                                                                              .UpdatedDatumText
                                                                                          )
                                                                                        ),
                                                                                      ],
                                                                                ]
                                                                              : header.value ==
                                                                                "MediaType"
                                                                              ? [
                                                                                  _vm.isEditing
                                                                                    ? _c(
                                                                                        "v-btn",
                                                                                        {
                                                                                          staticClass:
                                                                                            "dropdown-btn",
                                                                                          attrs:
                                                                                            {
                                                                                              disabled:
                                                                                                _vm.isSaving,
                                                                                              small:
                                                                                                "",
                                                                                              block:
                                                                                                "",
                                                                                              flat: "",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "span",
                                                                                            {
                                                                                              class:
                                                                                                {
                                                                                                  "success--text":
                                                                                                    _vm.isMediaTypeUpdate(
                                                                                                      props.data
                                                                                                    ),
                                                                                                },
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                _vm._s(
                                                                                                  props
                                                                                                    .data
                                                                                                    .UpdatedMediaType
                                                                                                )
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          _c(
                                                                                            "v-icon",
                                                                                            [
                                                                                              _vm._v(
                                                                                                "arrow_drop_down"
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                    : [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            props
                                                                                              .data
                                                                                              .UpdatedMediaType
                                                                                          )
                                                                                        ),
                                                                                      ],
                                                                                ]
                                                                              : header.value ==
                                                                                "SampleType"
                                                                              ? [
                                                                                  _vm.isEditing
                                                                                    ? _c(
                                                                                        "v-btn",
                                                                                        {
                                                                                          staticClass:
                                                                                            "dropdown-btn",
                                                                                          attrs:
                                                                                            {
                                                                                              disabled:
                                                                                                _vm.isSaving,
                                                                                              small:
                                                                                                "",
                                                                                              block:
                                                                                                "",
                                                                                              flat: "",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "span",
                                                                                            {
                                                                                              class:
                                                                                                {
                                                                                                  "success--text":
                                                                                                    props
                                                                                                      .data
                                                                                                      .UpdatedSampleType !=
                                                                                                    props
                                                                                                      .data
                                                                                                      .SampleType,
                                                                                                },
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                _vm._s(
                                                                                                  props
                                                                                                    .data
                                                                                                    .UpdatedSampleType
                                                                                                )
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          _c(
                                                                                            "v-icon",
                                                                                            [
                                                                                              _vm._v(
                                                                                                "arrow_drop_down"
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                    : [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            props
                                                                                              .data
                                                                                              .UpdatedSampleType
                                                                                          )
                                                                                        ),
                                                                                      ],
                                                                                ]
                                                                              : header.value ==
                                                                                "Flags"
                                                                              ? [
                                                                                  _vm.isEditing
                                                                                    ? _c(
                                                                                        "v-btn",
                                                                                        {
                                                                                          staticClass:
                                                                                            "dropdown-btn",
                                                                                          attrs:
                                                                                            {
                                                                                              disabled:
                                                                                                _vm.isSaving,
                                                                                              small:
                                                                                                "",
                                                                                              block:
                                                                                                "",
                                                                                              flat: "",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _vm._l(
                                                                                            props
                                                                                              .data
                                                                                              .UpdatedFlags,
                                                                                            function (
                                                                                              flag,
                                                                                              flagIndex
                                                                                            ) {
                                                                                              return _c(
                                                                                                "span",
                                                                                                {
                                                                                                  key: `updatedFlag-${index}-${flagIndex}`,
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "span",
                                                                                                    {
                                                                                                      class:
                                                                                                        {
                                                                                                          "success--text":
                                                                                                            !props.data.Flags.includes(
                                                                                                              flag
                                                                                                            ),
                                                                                                        },
                                                                                                    },
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        _vm._s(
                                                                                                          flag
                                                                                                        ) +
                                                                                                          "\n                                          "
                                                                                                      ),
                                                                                                      flagIndex <
                                                                                                      props
                                                                                                        .data
                                                                                                        .UpdatedFlags
                                                                                                        .length -
                                                                                                        1
                                                                                                        ? [
                                                                                                            _vm._v(
                                                                                                              "\n                                            ,  \n                                          "
                                                                                                            ),
                                                                                                          ]
                                                                                                        : _vm._e(),
                                                                                                    ],
                                                                                                    2
                                                                                                  ),
                                                                                                ]
                                                                                              )
                                                                                            }
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          _c(
                                                                                            "v-icon",
                                                                                            [
                                                                                              _vm._v(
                                                                                                "arrow_drop_down"
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                        ],
                                                                                        2
                                                                                      )
                                                                                    : [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            props.data.Flags.join(
                                                                                              ", "
                                                                                            )
                                                                                          )
                                                                                        ),
                                                                                      ],
                                                                                ]
                                                                              : header.value ==
                                                                                "Logs"
                                                                              ? [
                                                                                  _c(
                                                                                    "v-btn",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          small:
                                                                                            "",
                                                                                        },
                                                                                      on: {
                                                                                        click:
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            return _vm.showLogs(
                                                                                              props
                                                                                                .data
                                                                                                .Id
                                                                                            )
                                                                                          },
                                                                                      },
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "v-icon",
                                                                                        {
                                                                                          staticClass:
                                                                                            "mr-1",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "receipt_long"
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "text-none",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "Logs "
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                                ]
                                                                              : _c(
                                                                                  "span",
                                                                                  {
                                                                                    domProps:
                                                                                      {
                                                                                        innerHTML:
                                                                                          _vm._s(
                                                                                            props
                                                                                              .data[
                                                                                              header
                                                                                                .value
                                                                                            ]
                                                                                          ),
                                                                                      },
                                                                                  }
                                                                                ),
                                                                          ],
                                                                          2
                                                                        ),
                                                                      ]
                                                                    }
                                                                  ),
                                                                ],
                                                                2
                                                              ),
                                                              _vm._v(" "),
                                                              _c("hr"),
                                                            ]
                                                          },
                                                        },
                                                      ]),
                                                    }),
                                                  ],
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticStyle: {
                                    flex: "0 0 52px",
                                    "background-color": "#f7f7f7",
                                  },
                                },
                                [
                                  _c(
                                    "v-card-actions",
                                    [
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _vm.isEditing
                                        ? [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  disabled:
                                                    !_vm.hasUpdate ||
                                                    _vm.hasInvalidDatumData,
                                                  color: "success",
                                                  loading: _vm.isSaving,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.saveUpdatedResult()
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { staticClass: "mr-1" },
                                                  [_vm._v("done")]
                                                ),
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t("Button.Save")
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  disabled: _vm.isSaving,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.setEditing(false)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t("Button.Cancel")
                                                    )
                                                ),
                                              ]
                                            ),
                                          ]
                                        : [
                                            _vm.isTenantAdmin
                                              ? _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      disabled:
                                                        _vm.loading ||
                                                        _vm.isSaving,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.setEditing(
                                                          true
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass: "mr-1",
                                                        attrs: {
                                                          color: "warning",
                                                        },
                                                      },
                                                      [_vm._v("edit")]
                                                    ),
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t("Button.Edit")
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: { color: "primary" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.close()
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("Button.Close"))
                                                ),
                                              ]
                                            ),
                                          ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "800" },
          model: {
            value: _vm.logsDialog,
            callback: function ($$v) {
              _vm.logsDialog = $$v
            },
            expression: "logsDialog",
          },
        },
        [
          _c(
            "v-card",
            { staticStyle: { "background-color": "#f7f7f7" } },
            [
              _c(
                "v-card-title",
                {
                  staticClass: "headline",
                  staticStyle: { "justify-content": "center" },
                },
                [_vm._v("\n        Correction Logs\n      ")]
              ),
              _vm._v(" "),
              !_vm.CorrectionLogs.length && !_vm.Loaded
                ? _c("v-progress-linear", { attrs: { indeterminate: "" } })
                : _vm._e(),
              _vm._v(" "),
              _vm.CorrectionLogs.length && _vm.Loaded
                ? _c(
                    "v-card-text",
                    [
                      _c(
                        "v-expansion-panel",
                        _vm._l(_vm.CorrectionLogs, function (item, i) {
                          return _c(
                            "v-expansion-panel-content",
                            {
                              key: i,
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function () {
                                      return [
                                        _c("span", [
                                          _c("b", [
                                            _vm._v("Process Instance Number: "),
                                          ]),
                                          _vm._v(
                                            _vm._s(item.ProcessInstanceId) +
                                              "\n                "
                                          ),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("b", [_vm._v("Triggered By: ")]),
                                          _vm._v(
                                            _vm._s(item.TriggeredBy) +
                                              "\n                "
                                          ),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("b", [_vm._v("Date Time: ")]),
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatDate(
                                                item.DateTime,
                                                "MMMM DD, YYYY @ HH:mm"
                                              )
                                            ) + "\n                "
                                          ),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("b", [_vm._v("Notes: ")]),
                                          _vm._v(
                                            _vm._s(item.Notes) +
                                              "\n              "
                                          ),
                                        ]),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                {
                                  staticStyle: { padding: "12px 24px" },
                                  attrs: { row: "", wrap: "" },
                                },
                                [
                                  _c(
                                    "span",
                                    [
                                      _c("span", [
                                        _c("b", [_vm._v("Changes: ")]),
                                      ]),
                                      _c("br"),
                                      _vm._v(" "),
                                      _vm._l(
                                        item.Operations,
                                        function (i, index) {
                                          return _c(
                                            "v-chip",
                                            {
                                              key: index,
                                              attrs: { small: "" },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(i.PropertyName) +
                                                  " : \n                  "
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color: "#fb8c00",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(i.OriginalValue)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" → \n                  "),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color: "#4caf50",
                                                  },
                                                },
                                                [_vm._v(_vm._s(i.ResultValue))]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.CorrectionLogs.length && _vm.Loaded
                ? _c(
                    "v-card-text",
                    [
                      _c(
                        "v-alert",
                        {
                          attrs: {
                            value: _vm.showLogsError,
                            type: "error",
                            outline: "",
                          },
                        },
                        [
                          _vm._v(
                            "System fails to fetch logs for the lab result."
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-alert",
                        {
                          attrs: {
                            value: !_vm.showLogsError,
                            type: "warning",
                            outline: "",
                          },
                        },
                        [_vm._v("No Correction Logs.")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { outline: "", color: "secondary" },
                      on: {
                        click: function ($event) {
                          return _vm.closeLogs()
                        },
                      },
                    },
                    [_vm._v("close")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ConfirmationDialog", {
        ref: "confirmationDialog",
        attrs: {
          title: _vm.confirmationDialog.title,
          text: _vm.confirmationDialog.text,
          confirmText: _vm.confirmationDialog.confirmText,
          cancelText: _vm.confirmationDialog.cancelText,
          color: _vm.confirmationDialog.color,
        },
        on: { submit: _vm.confirmationDialog.action },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }